import { Controller } from '@hotwired/stimulus';
import {
  embedSignature,
  onSignliftEvent,
  finalizeSignature,
  SIGNLIFT_EVENTS,
} from '../lib/signlift';

export default class SignliftIframeController extends Controller {
  static values = {
    signingUrl: String,
    projectUrl: String,
    finalizeUrl: String,
  };

  static targets = ['container'];

  connect() {
    if (!this.hasContainerTarget) return;

    this.finalizeInflight = false;

    embedSignature(this.containerTarget, this.signingUrlValue);

    this.cleanup = onSignliftEvent(
      ({ type }) => this.handleEvent(type),
      this.signingUrlValue,
    );
  }

  disconnect() {
    this.cleanup?.();
  }

  handleEvent(type) {
    if (type === SIGNLIFT_EVENTS.SUCCESS) {
      this.triggerFinalize().finally(() => {
        window.location.href = this.projectUrlValue;
      });
    } else if (type === SIGNLIFT_EVENTS.ERROR) {
      window.location.href = this.projectUrlValue;
    }
  }

  triggerFinalize() {
    if (!this.finalizeUrlValue || this.finalizeInflight) {
      return Promise.resolve();
    }
    this.finalizeInflight = true;

    return finalizeSignature(this.finalizeUrlValue);
  }
}
